import { render, staticRenderFns } from "./OrderSheet4LabelSheet.vue?vue&type=template&id=2f4cbc10&scoped=true&class=labelsheet"
import script from "./OrderSheet4LabelSheet.vue?vue&type=script&lang=js"
export * from "./OrderSheet4LabelSheet.vue?vue&type=script&lang=js"
import style0 from "./OrderSheet4LabelSheet.vue?vue&type=style&index=0&id=2f4cbc10&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f4cbc10",
  null
  
)

export default component.exports